(function () {
'use strict';

angular.module("app.viewMenuBar", [])

    .service("viewMenuBarService", ['$rootScope', 'breadcrumbService',
        function ($rootScope, breadcrumbService) {

            var shownButtons = [];
            var buttonFunctions = [];
            var favorite;

            this.getShownButtons = function () {
                return shownButtons;
            };

            this.setButtons = function (buttons) {
                shownButtons = [];
                // init Home and Backbutton if not set as false

                for (var button in buttons) {
                    if(buttons[button] === false){
                        shownButtons[button] = 'hide';
                    }else{
                        shownButtons[button] = true;
                    }

                    buttonFunctions[button] = buttons[button];
                }
                $rootScope.$broadcast('viewMenuBarButtonChange');
            };

            this.changeButtons = function (buttons) {
                for (var button in buttons) {
                    shownButtons[button] = buttons[button];
                    buttonFunctions[button] = buttons[button];
                }
                $rootScope.$broadcast('viewMenuBarButtonChange');
            };

            this.executeFunction = function (button) {
                buttonFunctions[button]();
            };

            // favoriteObject: object
            // favoriteType:string e.g. 'Datapoint'
            // Favorite should be {favoriteObect:{...} , favoriteType:'..'}
            this.setFavorite = function (fav) {
                favorite = fav ? fav : false;
                $rootScope.$broadcast('viewMenuBarFavoriteChange');
            };

            this.getFavorite = function () {
                return favorite ? favorite : false;
            };

            // Do we show/hide the BackButton
            this.withBack = function(){
                // Back button should be available at:
                // BreadCrumb filled
                // Not forced to hide
               return breadcrumbService.isBack() && shownButtons['homeButton'] != 'hide' ;
            };

            // Do we show/hide the HomeButton
            this.withHome = function(){
                return breadcrumbService.isBack() && shownButtons['homeButton'] != 'hide';
            };

        }
    ])

    .directive('viewMenuBar', ['$rootScope', '$state', 'breadcrumbService', 'viewMenuBarService', 'frontEndSettingsService',
        function ($rootScope, $state, breadcrumbService, viewMenuBarService, frontEndSettingsService) {
            return {
                restrict: 'A',
                scope: {},
                templateUrl: 'views/viewMenuBar/viewMenuBar.html',

                /* @ngInject */
                controller: function ($scope) {
                    $scope.inputErrorMap = {};

                    $scope.buttonFunction = function (button) {
                        viewMenuBarService.executeFunction(button);
                    };

                    $scope.goToMain = function () {
                        let shouldReload = false;
                        /* Reload needed for a fresh favorites to be loaded on the main page.
                           Otherwise an old icon or an old favorite text can be displayed.  */
                        if ($state.current.name === 'favorites') {
                            shouldReload = true;
                        }

                        $state.go('main', undefined, { reload: shouldReload });
                    };

                    $scope.goBack = function () {
                        breadcrumbService.goBack();
                    };

                    // Show Back Button?
                    $scope.showBack = function () {
                        return viewMenuBarService.withBack();
                    };

                    // Show Home Button?
                    $scope.showHome = function () {
                        return viewMenuBarService.withHome();
                    };

                    $rootScope.$on('$viewContentLoaded', function () {
                        $scope.showButton = viewMenuBarService.getShownButtons();
                        $scope.favorite = viewMenuBarService.getFavorite();

                        $scope.showBackButton = breadcrumbService.isBack();
                        $scope.inputErrorMap = {};
                        $scope.inputErrorOccured = false;
                        if ($state.current.name === 'main') {
                            $scope.showColorBar = true;
                        } else {
                            $scope.showColorBar = false;
                        }
                    });

                    $rootScope.$on('viewMenuBarButtonChange', function () {
                        $scope.showButton = viewMenuBarService.getShownButtons();
                    });

                    $rootScope.$on('viewMenuBarFavoriteChange', function () {
                        $scope.favorite = viewMenuBarService.getFavorite();
                    });


                    $rootScope.$on('inputErrorOccured', function (e, data) {
                        if (data.error) {
                            $scope.inputErrorMap[data.$id] = true;
                            $scope.inputErrorOccured = true;
                        }
                        else {
                            $scope.inputErrorMap[data.$id] = false;
                            let stillError = false;
                            for (const input in $scope.inputErrorMap) {
                                if ($scope.inputErrorMap.hasOwnProperty(input)) {
                                    const element = $scope.inputErrorMap[input];
                                    if (element === true) {
                                        stillError = true;
                                        break;
                                    }
                                }
                            }

                            $scope.inputErrorOccured = stillError;
                        }
                        
                        
                        
                    });

                    frontEndSettingsService.getFrontendSettings()
                    .then(function(settings) {
                        if (settings.OrgId === 'boe') {
                            $scope.bottomBarColor = '2px solid #00B0F0';
                        } else {
                            /* $green */
                            $scope.bottomBarColor = '2px solid rgb(168,203,47)';
                        }
                    })
                }
            };
        }
    ]);

})();
